import { combineReducers } from '@reduxjs/toolkit'

import { draftsReducer, historyReducer, scheduledReducer } from './slices/createPostListSlice'

export const postsReducer = combineReducers({
  drafts: draftsReducer,
  scheduled: scheduledReducer,
  history: historyReducer,
})

export type PostsState = ReturnType<typeof postsReducer>
